import { CommonService } from "../../utils/common.services";
import {
  DELETE_API_CALL,
  GET_API_CALL,
  POST_API_CALL,
  PUT_API_CALL,
} from "../../utils/services";
import { ENDPOINTS } from "../../utils/endPoints";
import { FOLDER_TYPE } from "../../utils/contentTypes";
import { SUCCESS_TOAST } from "../../utils/showToast";
import toast from "react-hot-toast";
import { createParams } from "../../utils/commonFunctions";
import {
  UPDATE_ARTICLES_LIST,
  UPDATE_ARTICLES_LOADING,
} from "../../store/actionTypes";

export const getArticlesList = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_ARTICLES_LOADING });

    const { pageNo, limit, searchKey, sortOrder, sortBy, status } =
      getState().ArticleReducer;
    const params = createParams({
      pageNo,
      limit,
      search: searchKey,
      sortOrder,
      sortBy,
      status,
    });

    GET_API_CALL(ENDPOINTS.ARTICLES.GET_ARTICLES, params, (response) => {
      console.log("Article List Response :", response);
      if (response.isSuccess) {
        const { data = [], total = 0 } = response?.data || {};
        const totalPages = Math.ceil(total / limit);
        dispatch({
          type: UPDATE_ARTICLES_LIST,
          payload: {
            articlesList: data,
            total,
            totalPage: totalPages,
          },
        });
      }
      dispatch({ type: UPDATE_ARTICLES_LOADING });
    });
  };
};

export const deleteArticle = (articleId, callback) => {
  const toastId = toast.loading("Deleting article...");

  return () => {
    DELETE_API_CALL(
      ENDPOINTS.ARTICLES.DELETE_ARTICLE(articleId),
      (response) => {
        if (response.isSuccess) {
          toast.success(
            response?.data?.message || "Article deleted successfully",
            {
              id: toastId,
            },
          );
        } else {
          toast.error("Failed to delete article.", {
            id: toastId,
          });
        }

        toast.dismiss(toastId);

        if (callback) {
          callback(response);
        }
      },
    );
  };
};

export const ArticleService = {
  addArticles: async (articleData) => {
    const toastId = toast.loading("Creating article...");
    try {
      const defaultImage = await CommonService.uploadFileAndGetUrl(
        articleData.banner,
        FOLDER_TYPE.ARTICLE_IMAGE,
        true,
      );

      const dataToSend = {
        title: articleData.title,
        description: articleData.description,
        status: articleData.status,
        defaultImage: defaultImage,
        content: articleData.content,
        readTime: articleData.readTime,
        tags: articleData.tags,
      };

      const response = await new Promise((resolve, reject) => {
        POST_API_CALL(
          ENDPOINTS.ARTICLES.ADD_ARTICLES,
          dataToSend,
          (response) => {
            console.log("response of add article :", response);
            if (response.isSuccess) {
              resolve(response.data);
              toast.success("Article has been created successfully!", {
                id: toastId,
              });
            } else {
              toast.error("Failed to create article.", {
                id: toastId,
              });
              reject({});
            }
          },
        );
      });

      return response;
    } catch (error) {
      console.error("Add Article Failed:", error);
      return null;
    }
  },

  updateArticles: async (articleId, articleData, oldArticleData) => {
    const toastId = toast.loading("Updating article...");
    try {
      let defaultImage;
      if (articleData.banner) {
        defaultImage = await CommonService.uploadFileAndGetUrl(
          articleData.banner,
          FOLDER_TYPE.ARTICLE_IMAGE,
          true,
        );
      }

      const dataToSend = {
        title: articleData.title,
        description: articleData.description,
        status: articleData.status,
        defaultImage: defaultImage || oldArticleData?.defaultImage,
        content: articleData.content,
        readTime: articleData.readTime,
        tags: articleData.tags,
      };

      const response = await new Promise((resolve, reject) => {
        PUT_API_CALL(
          ENDPOINTS.ARTICLES.UPDATE_ARTICLES(articleId),
          dataToSend,
          (response) => {
            console.log("response of update article :", response);
            if (response.isSuccess) {
              resolve(response.data);
              toast.success("Article has been updated successfully!", {
                id: toastId,
              });
            } else {
              toast.error("Failed to update article.", {
                id: toastId,
              });
              reject({});
            }
          },
        );
      });

      const mediaToDelete = [...(articleData.removedMediaUrls || [])];
      if (articleData.banner && oldArticleData?.defaultImage) {
        mediaToDelete.push(oldArticleData.defaultImage);
      }

      await CommonService.deleteS3Files(mediaToDelete);

      return response;
    } catch (error) {
      console.error("Update Article Failed:", error);
      return null;
    }
  },
};
